/** `AgentTrigger.eventName` — matches the `EVENT_REGISTRY` key. */
export const LEAD_RECEIVED_EVENT_NAME = 'lead.received';
/** Unresolved lead event type — raw fields, no IDs. */
export const LEAD_INBOUND_EVENT_TYPE = 'communication.lead.received';
/** Resolved lead event type — contact/thread/session are present. */
export const LEAD_CREATED_EVENT_TYPE = 'communication.lead.created';
/** @deprecated Use LEAD_CREATED_EVENT_TYPE. */
export const LEAD_RECEIVED_PUBSUB_EVENT_TYPE = LEAD_CREATED_EVENT_TYPE;
export const LEAD_RECEIVED_VARIABLES = [
    'firstName',
    'lastName',
    'fullName',
    'phone',
    'email',
    'property',
    'message',
    'description',
    'source',
    'moveInDate',
    'creditScoreMin',
    'creditScoreMax',
    'income',
    'pets',
    'leaseLengthMonths',
    'numberOfBedrooms',
    'numberOfBathrooms',
    'numberOfOccupants',
    'leadChannel',
    'leadType',
    'dateSubmitted',
    'interests',
    'listingURL',
];
export const LEAD_RECEIVED_ENTRY = {
    variables: LEAD_RECEIVED_VARIABLES,
    defaultChannels: ['CALL', 'EMAIL'],
    pubsubEventType: LEAD_RECEIVED_PUBSUB_EVENT_TYPE,
};
//# sourceMappingURL=lead-received.js.map